// React
import React, { Component } from "react";

// Libraries
import Moment from 'moment';
import Scrollbar from 'react-smooth-scrollbar';

// Panel
import { PanelHeading, PanelBody } from '../../Components';
import { Article } from './';

import { ClientRoutes } from '../../Routes';

import './article.css';

class News extends Component {

/**********************************************************
 *  Constructor
 **********************************************************/
    constructor(props) {

        super(props);

        this.state = {
            filter : 'all',
            filters : ['trending','hot','bullish','bearish', 'important', 'lol', 'all'],
            articles : [],
            timestamp : 0,
            description : 'All of the latest crypto news aggregated',
            message : {
                title : 'Loading News',
                details : 'All of the latest news coming hot off the press.',
                type : 'warning'
            }
        };

    }


/**********************************************************
 *  Component Lifecycle Functions
 **********************************************************/

    // After first render, fetch all parameters and the corresponding chart
    componentDidMount() {

        //console.log('News.componentDidMount()');

        this.fetchLatestNews();

    }

    // After component update, check to see if news needs refresh
    componentDidUpdate(prevProps, prevState) {

        const now = Moment.utc().valueOf();

        if((now - this.state.timestamp) > 300000 || prevState.filter !== this.state.filter)
            this.fetchLatestNews();

    }

/**********************************************************
 *  Helper Functions
 **********************************************************/

    // Retrieves the latest news
    fetchLatestNews() {

        const now = Moment.utc().valueOf();

        ClientRoutes.getNews(this.state.filter, now)
            .then( (news) => {

                this.setState((prev, props) => {
                    return {
                        articles : news.articles,
                        timestamp : news.timestamp,
                        message : null
                    }
                });

            }).catch( (error) => {

            });

    }

    // Update the news filter
    selectFilter(filter) {

        this.setState((prev, props) => {
            return {
                filter : filter
            }
        });

    }

/**********************************************************
 *  Render
 **********************************************************/

  render() {

    //console.log('News.render()');

    return (

        <div className="panel panel-flat bg-theme-700">

            <PanelHeading title={"News"} description={this.state.description} sample={this.props.user === null ? true : false} refresh={null}>

                <div className="button-row">

                        <div className="dropdown">
                            <a type="button" className="btn btn-link dropdown-toggle legitRipple" 
                            data-toggle="dropdown" aria-expanded="true"> {this.state.filter}
                            <span className="caret"></span></a>
                            <ul className="dropdown-menu">
                            {
                                this.state.filters.sort().map( (filter) => {
                                    return (
                                        <li key={filter} onClick={() => this.selectFilter(filter)}><a href={null}>{ filter.toUpperCase() }</a></li>
                                    )
                                })
                            }
                            </ul>
                        </div>

                 </div>       

            </PanelHeading>

            <PanelBody loading={false} message={this.state.message}>

                        
                <div className="panes">
                    <Scrollbar damping={0.1} thumbMinSize={20} continuousScrolling={true} renderByPixels={false} alwaysShowTracks={false}>                            
                    <div className={this.props.mobile ? "articles mobile" : "articles"} >
                    {
                        this.state.articles.map( (article) => {

                            const url = 'http://' + article.domain + '/' + article.slug;
                            const timestamp = Moment().utc().from(Moment(article.created_at), true); // "5 days"
                            const timestampClass = timestamp.includes('hour') ? 'hour' : 'minute';

                            return (
                                <Article key={article.created_at} title={article.title} timestamp={timestamp} url={url} source={article.source.title} timestampClass={timestampClass}/>
                            )
                        })
                    }
                    </div>
                    </Scrollbar>

                    <div>

                    </div>

                </div>

            </PanelBody>

        </div>

    );
  }

}

export default News;





// WEBPACK FOOTER //
// ./src/Views/News/News.js